import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Error, InputCheckbox, Label } from 'shared/ui'
import { createChatbotEnrollSearchStore } from 'widgets/ChatbotEnroll/store/ChatbotEnrollSearchStore'
import { ChatbotEnrollModalSearch } from 'widgets/ChatbotEnroll/ui/ChatbotEnrollModalSearch'
import { SendFromBlockActionEditContent } from 'widgets/Flow/blocks/SendFrom'
import { type AITextingAgentStore } from '../../store/AITextingAgentStore'
import styles from './styles.module.scss'

type IAITextingAgentActionEditContentProps = {
  store: AITextingAgentStore
}

export const AITextingAgentActionEditContent = observer(
  ({ store }: IAITextingAgentActionEditContentProps) => {
    const searchStore = useMemo(() => createChatbotEnrollSearchStore(), [])
    const {
      sendFromBlockStore,
      isCheckCriteria,
      toggleIsCheckCriteria,
      setAiAgent,
      aiAgent,
      aiAgentError,
    } = store

    return (
      <div className={styles.wrap}>
        <div className={styles.field}>
          <Label label={{ text: 'Agent name' }} />
          <ChatbotEnrollModalSearch
            onSelect={setAiAgent}
            textFieldProps={{
              error: aiAgentError,
              className: styles.textField,
            }}
            selectedItem={aiAgent}
            searchStore={searchStore}
          />
          {!!aiAgentError && <Error type={'text'} error={aiAgentError} />}
        </div>

        {aiAgent && (
          <SendFromBlockActionEditContent labelText={'Select inbox'} store={sendFromBlockStore} />
        )}
        <InputCheckbox
          className={styles.checkbox}
          label='Check Agent enrollment criteria before enrolling contacts.'
          checked={isCheckCriteria}
          onChecked={toggleIsCheckCriteria}
        />
      </div>
    )
  }
)
